import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/timesheet/reasons` — le causali non sono più una sezione della rendicontazione (01-11-2026):
 * hanno una pagina a sé, `/organization/activity-reasons`, come in Lares. L'indirizzo resta come
 * rinvio, per i preferiti e i collegamenti salvati.
 */
export const Route = createFileRoute('/_app/timesheet/reasons')({
  beforeLoad: () => { throw redirect({ to: '/organization/activity-reasons', replace: true }); },
});
